import { render, staticRenderFns } from "./CustomPeriodField.vue?vue&type=template&id=096745a9&scoped=true&"
import script from "./CustomPeriodField.vue?vue&type=script&lang=ts&"
export * from "./CustomPeriodField.vue?vue&type=script&lang=ts&"
import style0 from "./CustomPeriodField.vue?vue&type=style&index=0&id=096745a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096745a9",
  null
  
)

export default component.exports